import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Library icon. Exported from Figma (Bombiix 2026). */
const LibraryIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M14.834 4.66699C14.8338 4.2069 14.4601 3.83398 14 3.83398H7.83398V12.167H14C14.4602 12.167 14.834 11.7942 14.834 11.334V4.66699ZM5.16699 14.667C5.16699 15.4954 5.83857 16.167 6.66699 16.167H13.5V13.167H6.66699C5.83867 13.167 5.16717 13.8387 5.16699 14.667ZM5.16699 12.6709C5.58513 12.3562 6.10338 12.167 6.66699 12.167H6.83398V3.83398H6.66699C5.83857 3.83398 5.16699 4.50556 5.16699 5.33398V12.6709ZM15.834 11.334C15.834 12.1731 15.2694 12.879 14.5 13.0967V16.167H15.334C15.6099 16.1672 15.8338 16.3911 15.834 16.667C15.834 16.943 15.61 17.1668 15.334 17.167H6.66699C5.28628 17.167 4.16699 16.0477 4.16699 14.667V5.33398C4.16699 3.95327 5.28628 2.83398 6.66699 2.83398H14C15.0124 2.83398 15.8338 3.65462 15.834 4.66699V11.334Z"
      fill="currentColor"
    />
  </svg>
);

export default LibraryIcon;
